@if (draftStore.entities().length === 0) { @if (draftStore.status() === 'error') {
<p-ai-chat-canvas-empty-state
    kind="error"
    [title]="'aichat.canvas.error.title' | translate"
    [message]="draftStore.message()"
></p-ai-chat-canvas-empty-state>
} @else {
<p-ai-chat-canvas-empty-state kind="info" [title]="'aichat.canvas.draft.empty.title' | translate"></p-ai-chat-canvas-empty-state>
} } @else { @if (intro(); as text) {
<p class="intro" automation-id="canvas-draft-intro">{{ text }}</p>
} @for (panel of panels(); track panel.entity.id) {
<div class="entity-card">
    <mat-expansion-panel
        class="entity-panel mat-elevation-z0"
        [expanded]="panel.expanded"
        [disabled]="creating()"
        (expandedChange)="setExpanded(panel, $event)"
    >
        <mat-expansion-panel-header
            class="entity-header"
            [attr.automation-id]="'canvas-tile-' + panel.automationKey"
            [matTooltip]="creating() ? ('aichat.canvas.draft.panel_disabled' | translate) : ''"
        >
            <mat-panel-title class="entity-title">
                <!-- The header toggles the panel on a click and on Space or Enter; the checkbox keeps its own. -->
                <span
                    class="selection"
                    [matTooltip]="selectionDisabled() ? ('aichat.canvas.draft.selection_disabled' | translate) : ''"
                    (click)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()"
                >
                    <p-checkbox
                        [checked]="panel.selected"
                        [disabled]="selectionDisabled()"
                        [ariaLabel]="panel.title ?? ('aichat.canvas.draft.entity.untitled' | translate)"
                        [attr.automation-id]="'canvas-entity-checkbox-' + panel.automationKey"
                        (checkedChange)="select(panel.entity.id, $event)"
                    ></p-checkbox>
                </span>
                <span>{{ panel.position }} {{ panel.title ?? ('aichat.canvas.draft.entity.untitled' | translate) }}</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <p-ai-chat-draft-entity class="entity-body" [entity]="panel.entity" [entityType]="panel.entityType"></p-ai-chat-draft-entity>
        </ng-template>
    </mat-expansion-panel>
</div>
} }
